import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      // TODO: Support notifications (version of onErrorToastData with Fenrir v2)
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      // TODO: Support notifications (version of onErrorToastData with Fenrir v2)const fetchError = error as any; // instanceof ResponseError does not work here
    },
  }),
});
